<template>
  <v-card>
    <v-card-title class="headline">
      <v-icon>check</v-icon>
      Crear suspensión movilidad:
      <v-spacer />
      <v-btn icon @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <strong>Tipo de movilidad:</strong>
              {{ movilidad.tipo_movimiento }}
            </v-flex>
            <v-flex md12>
              <strong>Servidor público:</strong>
              {{ movilidad.funcionario.nombre }}
            </v-flex>
            <v-flex md6>
              <strong>Item:</strong> {{ movilidad.nro_item }}
            </v-flex>
            <v-flex md6>
              <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md4>
              <v-text-field
                type="date"
                label="Fecha desde"
                v-model="form.fecha_desde"
                :rules="$validate(['required'])"
                @input="esFeriadoOFinDeSemana(form.fecha_desde,1)"
                required
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :loading="loading"
      
          @click="aprobarRechazar(1)"
        >
          <v-icon>check</v-icon> Crear
        </v-btn>
        <!-- <v-btn color="error" :loading="loading" @click="aprobarRechazar(0)">
          <v-icon>clear</v-icon> Rechazar
        </v-btn> -->
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  mixins: [validate],
  props: ["movilidad"],
  data() {
    return {
      loading: false,
      valid: false,
      form: {},
      fecha_desde: null,
      bandera_fecha: false,
    };
  },
  methods: {
    close() {
      this.$bus.$emit("closeDialogAprobar");
    },
    async esFeriadoOFinDeSemana(fecha,valor){},
       async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ",fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(`La fecha ${this.$moment(fecha).format('DD/MM/YYYY')} cae en fin de semana o feriado`);
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async aprobarRechazar(tipo) {
   
      if (this.$refs.form.validate()) {
        try {
          if (this.form.fecha_desde) {
              let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
                this.form.fecha_desde,
                1
              );
              if (validacion_fecha) {
                return;
              }
            }
          let resps = [];
          let correcto = true;
          this.loading = true;
          let user = this.$storage.get("user");
          let temp = this.$moment(
            this.movilidad.fecha_desde,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          console.log(`
            query{
              runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_suspension(${this.movilidad.funcionario.id_persona}, ${user.id},'${this.form.fecha_desde}', 2)"){
                respuesta
              }
            }
          `);
          let res = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_suspension(${this.movilidad.funcionario.id_persona}, ${user.id},'${this.form.fecha_desde}', 2)"){
                respuesta
              }
            }
          `,
          });
          res = res.runQuery.respuesta[0].fn_alta_movilidad_suspension;
          resps = res.split("|");
          correcto = resps[0];
          console.log(correcto);
          if (correcto === "1") {
            this.$message.success();
          } else {
            this.$message.error(resps);
          }
          this.loading = false;
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/AprobarSuspencionItem.vue